/** @format */

export enum ImageOptimizedSize {
	THUMBNAIL_XS = 80,
	THUMBNAIL_M = 252,
	TABLET_XS = 600,
}
